import CryptoJS from "crypto-js";

// encrypt a string with salt
export const saltEncrypt = (str, salt) => {
  // const key = CryptoJS.enc.Utf8.parse(salt);
  // const iv = CryptoJS.enc.Utf8.parse(salt);
  const key = salt;
  const iv = salt;
  const encrypted = CryptoJS.AES.encrypt(str, key, {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

// decrypt a string with salt
export const saltDecrypt = (str, salt) => {
  // const key = CryptoJS.enc.Utf8.parse(salt);
  // const iv = CryptoJS.enc.Utf8.parse(salt);
  const key = salt;
  const iv = salt;
  const decrypted = CryptoJS.AES.decrypt(str, key, {
    keySize: 128 / 8,
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const saltEncryptAndEncode = (str, salt) =>
  encodeURIComponent(saltEncrypt(str, salt));

export const decodeAndSaltDecrypt = (str, salt) =>
  saltDecrypt(decodeURIComponent(str), salt);

// decode a string with salt
